import axios from 'axios';
import constants from "../../../Util/constants";
import { toast } from 'react-toastify';

const log = require("loglevel").getLogger("UserService");
log.setLevel("debug");

axios.interceptors.request.use(request => {
	// log.info('Starting Request', request.url);
	return request;
});

axios.interceptors.response.use(response => {
	// //console.log('Response:', response)
	return response;
});

export const signIn = async user => {
console.log("UserService -> signIn -> Enter");

	return axios.post(`${constants.BASE_URL}/agent/login`, user)
		.then(async response => {
			const res = response.data;
			// log.debug("UserService -> signIn -> response: " + res);
			toast.success(res.message, {
				position: 'top-right',
				toastClassName: 'custom-toast',
			});
			return res;
		})
		.catch(response => {
			// log.debug("userService -> signIn -> error: ");
			log.debug(response);
			 
			toast.error(response.response.data.message, {
				position: 'top-right',
				toastClassName: 'custom-toast',
			});
	return null;
})
};

// Silent probe for the unified /login flow: no toasts. The unified flow tries
// the agent login first and falls back to the partner lookup, so toasting the
// probe's "agent Email not found" would flash an error at every partner login.
// A 200 without token+agent (unapproved / collaborator / partner-manager) is
// not a usable session, so it is reported as a failure with the message.
export const signInSilent = async user => {
	try {
		const res = (await axios.post(`${constants.BASE_URL}/agent/login`, user)).data;
		if (res?.token && res?.agent) {
			return { ok: true, agent: res.agent, token: res.token, message: res.message };
		}
		return { ok: false, status: 200, message: res?.message };
	} catch (err) {
		log.debug(err);
		return { ok: false, status: err?.response?.status, message: err?.response?.data?.message };
	}
};

// Partner login: VT-Backend issues the partner's session (shared internal account) after
// the hub confirms the partner session — no password in the bundle, no hub token.
// Asana 1218458529003876.
export const extranetPartnerSession = async (hub, token) => {
	try {
		const res = (await axios.post(`${constants.BASE_URL}/agent/extranet-partner-session`, { hub, token })).data;
		if (res?.token && res?.agent) {
			return { ok: true, agent: res.agent, token: res.token, message: res.message };
		}
		return { ok: false, status: 200, message: res?.message };
	} catch (err) {
		log.debug(err);
		return { ok: false, status: err?.response?.status, message: err?.response?.data?.message };
	}
};

export const signInEx = async user => {
	log.debug("UserService -> signInEx -> Enter");

	return axios.post(`${constants.SHUB_URL}/external-partners/login`, user)
		.then(async response => {
			const res = response.data;
			// log.debug("UserService -> signIn -> response: " + res);
			toast.success(res.message, {
				position: 'top-right',
				toastClassName: 'custom-toast',
			});
			return res;
		})
		.catch(response => {
			// log.debug("userService -> signIn -> error: ");
			log.debug(response);
			 
			toast.error(response.response.data.message, {
				position: 'top-right',
				toastClassName: 'custom-toast',
			});
	return null;
})
};
 
export const sendtwoFAcode = async user => {
	log.debug("UserService -> twofa -> Enter");

//By Jaison on 2025-04-29 START
//To add source=VT
const userData = user;
userData['source'] = 'VT';
//By Jaison on 2025-04-29 END

	return axios.post(`${constants.SHUB_URL}/local/partners/twofa`, user)
		.then(async response => {
			const res = response.data;
			// log.debug("UserService -> signIn -> response: " + res);
			if(res.success) {
				toast.success(res.message, {
					position: 'top-right',
					toastClassName: 'custom-toast',
				});
				
			} else {
				toast.error(res.message, {
					position: 'top-right',
					toastClassName: 'custom-toast',
				});
			}
			return res;
			
		})
		.catch(response => {
			// log.debug("userService -> signIn -> error: ");
			log.debug(response);
			 
			toast.error(response.response.data.message, {
				position: 'top-right',
				toastClassName: 'custom-toast',
			});
	return null;
})
};

export const signUp = async user => {
	log.debug("UserService -> signUp -> Enter");

	return axios.post(`${constants.BASE_URL}/agent/signup`, user)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> signUp -> response: " + res.data?.user);
			return res;
		})
		.catch(response => {
			log.debug("userService -> signUp -> error: ");
			log.debug(response);
			return null;
		})
};

export const forgotPassword = async email => {
 
	return axios.post(`${constants.BASE_URL}/agent/forget-password`, { email })
		.then(async response => {
			const res = response.data;
			console.log(response,"mayur")
		 
 			return res;
		})
		.catch(response => {
			log.debug(response);
			return null;
		})
};

export const signOut = () => {
	try {
	}
	catch (e) { }
};

